<div class="kyb-individual-trustee-dialog">
  <mat-dialog-content>
    <div class="row">
      <div class="col-12">
        <div class="mat-h4-custom">{{data.title ?? 'Individual trustee details'}}</div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-md-12">
        <name title="First Name" [mark]="markObservable" [formControl]="formControlFirstName"></name>
      </div>
      <div class="col-lg-6 col-md-12">
        <name title="Middle Name" [mandatory]="false" [mark]="markObservable" [formControl]="formControlMiddleName"></name>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-md-12">
        <name title="Last Name" [mark]="markObservable" [formControl]="formControlLastName"></name>
      </div>
      <div class="col-lg-6 col-md-12">
        <datepicker
          title="Date of birth"
          [mark]="markObservable"
          [formControl]="formControlDob"
          [allowOnly18YrsPlus]="true">
        </datepicker>
      </div>
    </div>

    @if (duplicateError) {
      <div class="row">
        <div class="col-12">
          <mat-error>{{duplicateError}}</mat-error>
        </div>
      </div>
    }
    @if (duplicateWarning && !duplicateError) {
      <div class="row">
        <div class="col-12">
          <div class="duplicate-warning">{{duplicateWarning}}</div>
        </div>
      </div>
    }

    <div class="row separator-top">
      <div class="col-12" fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-stroked-button (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="primary" (click)="onSubmit()">
          {{duplicateWarning && !duplicateError ? 'Add anyway' : 'Save'}}
        </button>
      </div>
    </div>
  </mat-dialog-content>
</div>
